import { createRouter, createWebHistory } from 'vue-router'
import LandingView from '@/views/LandingView.vue'
import ThankYouView from '@/views/ThankYouView.vue'
import ErrorView from '@/views/ErrorView.vue'

const routes = [
  { path: '/', name: 'landing', component: LandingView },
  { path: '/thank-you', name: 'thank-you', component: ThankYouView },
  { path: '/error', name: 'error', component: ErrorView },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
